export default "__VITE_ASSET__C6H_5Chi__"